import { z } from 'zod';

/**
 * Trimmed Kartverket stedsnavn (SSR) search result (spec 13) — the API proxy
 * never forwards SSR's raw payload, only these fields. `type` is SSR's
 * `navneobjekttype`, already nb-NO (e.g. "Havn", "Øy", "Skjær").
 * `municipality` is null when SSR reports no `kommuner` for the hit (rare,
 * e.g. some open-water features).
 */
export const searchHit = z.object({
  name: z.string(),
  type: z.string(),
  municipality: z.string().nullable(),
  lat: z.number(),
  lon: z.number(),
});
export type SearchHit = z.infer<typeof searchHit>;

export const searchResponse = z.object({
  hits: z.array(searchHit),
});
export type SearchResponse = z.infer<typeof searchResponse>;
